// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--93a7da","primaryButton":"style--primaryButton--70fb9f"};